import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import moment from "moment";
import { createPinia } from "pinia";
import LmsModal from "./components/module/Modal.vue";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import Vue3VideoPlayer from "@cloudgeek/vue3-video-player";
import "@cloudgeek/vue3-video-player/dist/vue3-video-player.css";

import Vue3Toastify, { type ToastContainerOptions } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
//import excel from "vue-excel-export";
import VueFrame from "@vueframe/vueframe";
import VueSocialSharing from "vue-social-sharing";
import VueTheMask from "vue-the-mask";
import Vue3Marquee from "vue3-marquee";
import { VueClipboard } from "@soerenmartius/vue3-clipboard";
import Popper from "vue3-popper";
import { createHead } from "@vueuse/head";
import { vLazy } from "./directives/vLazy";

const app = createApp(App);
const head = createHead();
/**
 * @params {date} date to be converted to timeago
 * @returns returns timeAgo
 */
app.config.globalProperties.$filters = {
  timeAgo(date) {
    return moment(date).fromNow();
  },
};

//const app = createApp(App);
app.component("LmsModal", LmsModal);
app.component("VueDatePicker", VueDatePicker);
app.component("Popper", Popper);

const options = {
  confirmButtonColor: "#41b882",
  cancelButtonColor: "#ff7674",
};
app.use(Vue3VideoPlayer, {
  lang: "en",
});
app.use(Vue3Toastify, {
  autoClose: 3000,
} as ToastContainerOptions);
app.use(VueSweetalert2, options);
app.use(createPinia());
//app.use(excel);
app.use(VueFrame);
app.use(VueSocialSharing);
app.use(VueTheMask);
app.use(Vue3Marquee);
app.use(VueClipboard);
app.use(head);
app.directive("lazy", vLazy);
app.use(store).use(router).mount("#app");
